import loadable from 'components/dynamic-import';

export const Rewind = loadable(() => import('./Rewind'));
export const RewindSocial = loadable(() => import('./RewindSocial'));
export { RewindAlert } from './components/alert';
